// File: src/components/HeroCategoryCardsSection.jsx
// Amazon-style category discovery section
// Container for multiple ProductCategoryCards
// 
// Responsive layout:
// - Mobile: 1-2 cards (vertical stack)
// - Tablet: 2 cards per row
// - Desktop: 4 cards per row
//
// Data: Receives first 4 categories from API, each with 4 subcategories
// Routing: Each card navigates to category or subcategory pages

import React from 'react';
import ProductCategoryCard from './ProductCategoryCard';

const HeroCategoryCardsSection = ({ categories }) => {
  // Don't render if no valid categories data
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-white px-4 py-6 md:py-8 border-t border-gray-100 shadow-sm">
      <div className="container mx-auto">
        
        {/* Desktop Layout: 4 cards in a single row (Amazon-style) */}
        <div className="hidden lg:grid grid-cols-4 gap-4">
          {categories.map((category) => (
            <ProductCategoryCard
              key={category.id}
              category={category}
            />
          ))}
        </div>

        {/* Tablet Layout: 2 cards per row, showing all 4 cards in 2 rows */}
        <div className="hidden md:grid lg:hidden grid-cols-2 gap-4">
          {categories.slice(0, 4).map((category) => (
            <ProductCategoryCard
              key={category.id}
              category={category}
            />
          ))}
        </div>

        {/* Mobile Layout: 1 card per row, showing first 2 cards only (performance) */}
        <div className="md:hidden flex flex-col gap-4">
          {categories.slice(0, 4).map((category) => (
            <ProductCategoryCard
              key={category.id}
              category={category}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default HeroCategoryCardsSection;
